import React, { useState } from "react";
import Image from "../common/Image";
import { policiesData } from "../../config/homePageUtils";
import Button from "../common/Button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const PoliciesSection = () => {
  const [activeTab, setActiveTab] = useState(
    policiesData.tabs.find((tab) => tab.active)?.id,
  );
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <section className="max-w-7xl mx-auto px-4 py-24" id="Policies">
      {/* Heading */}
      <h1 className="text-7xl font-extrabold text-center mb-10 bg-clip-text clip-text-img text-transparent bg-gradient-to-r from-green-800 to-green-400">
        {language ? policiesData.heading.hi : policiesData.heading.en}
      </h1>

      {/* Tabs */}
      <div
        className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8 text-center top-tabs"
        id="tabs"
      >
        {policiesData.tabs.map((tab) => (
          <div key={tab.id} className="relative inner-tabs">
            <button
              onClick={() => setActiveTab(tab.id)}
              id={`tabBtn-${tab.id}`}
              className={`tab-btn bg-[#018f9b] text-white px-4 py-6 rounded-lg shadow flex flex-col items-center justify-center h-full w-full transition ${
                activeTab === tab.id
                  ? "bg-[#018f9b] text-white"
                  : "bg-white border border-gray-300 text-black"
              }`}
            >
              <div className="text-2xl">
                <Image
                  src={tab.icon}
                  className={`icon-img ${tab.iconClasses} w-8 h-8 ${
                    activeTab === tab.id ? "invert" : ""
                  }`}
                />
              </div>
              <div
                className={`text-sm font-semibold mt-2 leading-tight ${
                  activeTab === tab.id ? "text-white" : "text-black"
                }`}
              >
                {(language ? tab.title.hi : tab.title.en)
                  .split("<br>")
                  .map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
              </div>
            </button>
            <div
              className={`arrow-down mt-[-4px] ${
                activeTab === tab.id ? "" : "hidden"
              }`}
              id={`arrow-${tab.id}`}
            ></div>
          </div>
        ))}
      </div>

      {/* Tab Content */}
      {policiesData.tabs.map((tab) => (
        <div
          key={tab.id}
          id={tab.id}
          className={`tab-content ${activeTab === tab.id ? "block" : "hidden"}`}
        >
          <div className="bg-[#018f9b] text-white rounded-xl shadow-lg p-10 flex flex-col lg:flex-row items-center lg:items-start lg:items-center space-y-6 lg:space-y-0 lg:space-x-6 text-center lg:text-left">
            <Image
              src={tab.img}
              alt="Policy Poster"
              className="w-full sm:w-64 rounded-lg border-2 border-white shadow-lg"
            />
            <div className="flex-1">
              <h3 className="text-sm text-white uppercase font-semibold mb-1">
                {language ? "नीतियाँ" : "Policies"}
              </h3>
              <h2 className="text-2xl font-bold mb-3 text-white">
                {language ? tab.title.hi : tab.title.en}
              </h2>
              <p className="mb-4 text-white">
                {language ? tab.description.hi : tab.description.en}
              </p>
              <Button
                onClick={() => {
                  navigate(tab.to);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="inline-flex items-center text-white mt-3 font-semibold hover:underline text-lg"
              >
                <span className="svg-icon">
                  <svg
                    className="w-7 h-7"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10.293 15.707a1 1 0 010-1.414L13.586 11H4a1 1 0 110-2h9.586l-3.293-3.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" />
                  </svg>
                </span>
                {language ? "और पढ़ें" : "Read More"}
              </Button>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default PoliciesSection;
